export default "assets/images/56f7003805ed02f8a21199947651db2e.png";